import { useMutation } from '@tanstack/react-query';
import { apiService } from '../../services/api';
import type { SimulationRequest, SimulationReport } from '../../types/manufacturing';

// STD-015: write/imperative actions for the Manufacturing domain. The order
// simulation is a user-triggered POST, so it is a mutation rather than a query.
// It opts out of the global error toast (skipGlobalErrorToast) because
// BomTreeSimulate renders a persistent inline Alert from mutation.isError —
// matching the original toast-free behavior and avoiding a double notification.

export function useManufacturingSimulation() {
  return useMutation<SimulationReport, Error, SimulationRequest>({
    meta: { skipGlobalErrorToast: true },
    mutationFn: (request: SimulationRequest) => apiService.getManufacturingSimulation(request),
  });
}
